import WaveSurfer from "../../node_modules/wavesurfer.js/dist/wavesurfer.esm.js";

class Wavesurfer {
  constructor() {
    this.wavesurferContainer = document.querySelector('.lc-start-quote__waveform');
    this.wavesurferButton = document.querySelector('.js-quote-audio-button');
    this.wavesurferAudio = 'https://report.strabag.com/2025/ar/downloads/de/bpk_sky_de_mixdown.mp3';
    // SHOULD BE UPLOADED FROM Audio Startseite in downloads!!!!!!
    // Localhost testing - use local file
    if(location.hostname === 'localhost' || location.hostname === '127.0.0.1'){
      this.wavesurferAudio = '/downloads/de/bpk_sky_de_mixdown.mp3';
    }

    // DELETE if wrong file is used in live
      if(location.hostname.includes('my.nswow.ch')){
        this.wavesurferAudio = 'https://my.nswow.ch/hosting/strabag/geschaeftsbericht-2025/preview/downloads/de/bpk_sky_de_mixdown.mp3';
      }
    // END OF DELETE

    if(document.documentElement.lang == 'en'){
      this.wavesurferAudio = 'https://report.strabag.com/2025/ar/downloads/en/bpk_sky_en_mixdown.mp3';

      // Localhost testing - use local file
      if(location.hostname === 'localhost' || location.hostname === '127.0.0.1'){
        this.wavesurferAudio = '/downloads/en/bpk_sky_en_mixdown.mp3';
      }

       // DELETE if wrong file is used in live
        if(location.hostname.includes('my.nswow.ch')){
          this.wavesurferAudio = 'https://my.nswow.ch/hosting/strabag/geschaeftsbericht-2025/preview/downloads/en/bpk_sky_en_mixdown.mp3';
        }
      // END OF DELETE
    }

    if(this.wavesurferContainer){
      this.bindWavesurfer();
    }
  }

  bindWavesurfer() {
    const wavesurfer = WaveSurfer.create({
      container: this.wavesurferContainer,
      waveColor: '#000000',
      progressColor: '#D72622',
      height: 40,
      cursorWidth: 2,
      barWidth: 2,
      barGap: 3,
      barRadius: 30,
      barHeight: .9,
      url: this.wavesurferAudio
    })

    this.wavesurferButton.addEventListener('click', () => {
      wavesurfer.playPause()
    })

    wavesurfer.on('play', () => {
      this.wavesurferButton.classList.toggle('is-playing');
    })

    wavesurfer.on('pause', () => {
      this.wavesurferButton.classList.toggle('is-playing');
    })

    wavesurfer.on('interaction', () => {
      wavesurfer.play()
    })
  }
}


export default Wavesurfer;
